import { render, staticRenderFns } from "./CriticalError.vue?vue&type=template&id=5520b896"
import script from "./CriticalError.vue?vue&type=script&lang=ts"
export * from "./CriticalError.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports